import React from 'react';
import { connect } from 'react-redux';
import moment from 'moment';
import 'moment-timezone';

import { getTimezoneFromState } from 'helpers/intl';

class IntlDateTimeRaw extends React.Component {
  getTimezone = () => {
    const { defaultTimezone, timezone } = this.props;
    return timezone || defaultTimezone;
  };

  render() {
    const { date, forwardedRef } = this.props;

    let tzDate = moment.tz(date, 'UTC');
    tzDate = tzDate.tz(this.getTimezone());

    return <span ref={forwardedRef}>{tzDate.format('l LT')}</span>;
  }
}

const mapStateToProps = state => {
  return {
    defaultTimezone: getTimezoneFromState(state),
  };
};

const ConnectedIntlDateTime = connect(mapStateToProps)(IntlDateTimeRaw);
// eslint-disable-next-line react/display-name
const IntlDateTime = React.forwardRef((props, ref) => <ConnectedIntlDateTime forwardedRef={ref} {...props} />);
export default IntlDateTime;
